import { Clock, LogOut, RefreshCw } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import Button from '@/components/common/Button';

export default function PendingApprovalPage() {
  const { cmsUser, logout, refreshUser } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-surface-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">

        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-100 mb-6">
          <Clock className="h-10 w-10 text-amber-600" />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-surface-900 mb-2">
          Awaiting Approval
        </h1>

        {/* Message */}
        <div className="bg-white rounded-2xl shadow-card border border-surface-200 p-6 mb-6 text-left space-y-3">
          <p className="text-surface-700">
            Hello <span className="font-medium">{cmsUser?.displayName ?? 'there'}</span>,
          </p>
          <p className="text-surface-600 text-sm leading-relaxed">
            Your account has been created and is waiting for an administrator to
            review and approve your access. This is usually done within 24 hours.
          </p>
          <p className="text-surface-600 text-sm leading-relaxed">
            Once approved, you'll be able to sign in and access the WombCat CMS.
            You may need to refresh or sign in again after approval.
          </p>

          <div className="pt-2 border-t border-surface-100">
            <p className="text-xs text-surface-400">
              Registered with:{' '}
              <span className="font-medium text-surface-600">{cmsUser?.email}</span>
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <Button
            variant="secondary"
            fullWidth
            leftIcon={<RefreshCw className="h-4 w-4" />}
            onClick={refreshUser}
          >
            Check approval status
          </Button>
          <Button
            variant="ghost"
            fullWidth
            leftIcon={<LogOut className="h-4 w-4" />}
            onClick={logout}
          >
            Sign out
          </Button>
        </div>

      </div>
    </div>
  );
}
